import { BaseMarkerHandles } from '../base/baseMarkerHandles'
import { BezierLineMarker } from './bezierLineMarker'
import { CircleHandle } from '../handles/circleHandle'
import { BezierAdjustmentHandle } from './bezierAdjustmentHandle'

export class BezierLineMarkerHandles extends BaseMarkerHandles<BezierLineMarker, CircleHandle> {
  //TODO need to revisit populating handle positions for markers
  //Rect and polygon marker rely on clones of the original points
  //While bezier relies on the points being passed in and having reference
  //to the originals.

  //Bezier does not need to populate points due to this but any adjustment made to the
  //original points also gets applied to the handle points
  //Which may or may not be the best behaviour.

  //One apporach should be chosen for all markers
  populateHandlePositions(): void {
    return
  }
  populateHandles(): void {
    const state = this.marker.state
    const handles = state.handles
    const controlPoints = state.controlPoints
    this.marker.state.anchorPoints?.forEach((point, i) => {
      let newHandle
      if (i === 0) {
        newHandle = new BezierAdjustmentHandle(
          this.marker.p,
          point,
          { start: null, end: null },
          state.handleRadius,
          state.handleStrokeWeight
        )
      } else {
        const latestHandle = handles[handles.length - 1]
        const newControlPoint = {
          start: Object.assign({}, latestHandle.position),
          end: Object.assign({}, point),
        }
        const newHandleControlPointPositions = {
          start: newControlPoint.end,
          end: null,
        }
        newHandle = new BezierAdjustmentHandle(
          this.marker.p,
          point,
          newHandleControlPointPositions,
          state.handleRadius,
          state.handleStrokeWeight
        )
        latestHandle.controlPointPositions = {
          ...latestHandle.controlPointPositions,
          end: newControlPoint.start,
        }
        controlPoints.push(newControlPoint)
      }
      handles.push(newHandle)
    })
  }

  populate(): void {
    const state = this.marker.state
    if (state.handles.length !== state.anchorPoints.length) {
      this.populateHandles()
    }
  }
}
